export default __webpack_public_path__ + "static/media/map.65b4b0ec.svg";